import { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { AiFillEdit, AiOutlineDelete } from "react-icons/ai";
import { IoMdArrowBack } from "react-icons/io";
import {
    useAddPackingItemsMutation,
    useDeletePackingItemsMutation,
    useGetAllPackingItemsQuery,
    useUpdatePackingItemsMutation,
} from "../../Data/services/PackingItems";
import Toast from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import LoadingButton from "../CustomComponents/LoadingButton";

const ViewPackingItems = ({ rowData }) => {
  const {
    control,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [editData, setEditData] = useState(null);
  const [delteData, setDelteData] = useState(null);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllPackingItemsQuery(
      {
        packing_type_slug: rowData?.slug,
      },
      { refetchOnMountOrArgChange: true }
    );
  console.log(data?.data);

  const [
    add,
    { isSuccess: isSuccessAdd, isLoading: isLoadingAdd, isError: isErrorAdd },
  ] = useAddPackingItemsMutation();
  const [
    update,
    {
      isSuccess: isSuccessUpdate,
      isLoading: isLoadingUpdate,
      isError: isErrorUpdate,
    },
  ] = useUpdatePackingItemsMutation();

  const [
    deleteData,
    {
      isSuccess: isSuccessDelete,
      isLoading: isLoadingDelete,
      isError: isErrorDelete,
    },
  ] = useDeletePackingItemsMutation();

  const onAdd = async (data) => {
    data["packing_type_slug"] = rowData?.slug;
    try {
      let response = await add(data).unwrap();
      Toast(response?.message, "success");
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  const onUpdate = async (data) => {
    try {
      let response = await update({ id: editData?.slug, data: data }).unwrap();
      Toast(response?.message, "success");
      setEditData(null);
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  const onDelete = async (dt) => {
    try {
      let response = await deleteData(dt?.slug).unwrap();
      Toast(response?.message, "success");
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  useEffect(() => {
    if (editData) {
      setValue("name", editData?.name);
    } else {
      setValue("name", "");
    }
  }, [editData]);
  return (
    <div className="w-100 mt-3">
      {!editData ? (
        <>
          {isLoading ? (
            <div className="flex-center">
              <LoadingButton />
            </div>
          ) : (
            <>
              {data?.data?.length > 0 ? (
                data?.data?.map((dt) => (
                  <div className="flex-between">
                    <li className="p-0 mt-2 fs-7 fw-normal text-black">
                      {dt?.name}
                    </li>
                    <div className="d-flex gap-2">
                      <AiFillEdit
                        size={18}
                        className="cursor-pointer"
                        onClick={() => setEditData(dt)}
                      />
                      <AiOutlineDelete
                        size={18}
                        color="red"
                        onClick={() => onDelete(dt)}
                        className="cursor-pointer"
                      />
                    </div>
                  </div>
                ))
              ) : (
                <p>No Data Found</p>
              )}
              <div className="mt-4">
                <p className="fs-5 fw-bolder">Add More</p>
                <Form onSubmit={handleSubmit(onAdd)}>
                  <Controller
                    control={control}
                    name="name"
                    render={({ field }) => (
                      <InputGroup className="mb-3">
                        <Input placeholder="Name" type="text" {...field} />
                      </InputGroup>
                    )}
                  />
                  <Button
                    text={<>{isLoadingAdd ? <LoadingButton /> : "Add"}</>}
                    classes="mt-3 mb-2"
                    type="submit"
                  />
                </Form>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <div
            className="ms-auto d-flex align-items-center cursor-pointer"
            onClick={() => setEditData(null)}
          >
            <IoMdArrowBack size={18} color="black" className="my-3 gap-2" />
            <p className="p-0 m-0">Back</p>
          </div>
          <Form onSubmit={handleSubmit(onUpdate)}>
            <Controller
              control={control}
              name="name"
              render={({ field }) => (
                <InputGroup className="mb-3">
                  <Input placeholder="Name" type="text" {...field} />
                </InputGroup>
              )}
            />
            <Button
              text={<>{isLoadingUpdate ? <LoadingButton /> : "Update"}</>}
              classes="mt-3 mb-2"
              type="submit"
            />
          </Form>
        </>
      )}
    </div>
  );
};

export default ViewPackingItems;
